import React from 'react';
import { useChatContext } from 'stream-chat-react';
import { prime_badgeColor, countUnreadPerChannel } from '../../utils';
import { PrimeEditModal, PrimeManageModal } from '../Modals';
import { ChipUnitCodes } from '../ChipUnitCodes';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import Chip from '@mui/material/Chip';
import Box from '@mui/material/Box';
import parseMax from 'libphonenumber-js/max';
import ArchiveIcon from '@mui/icons-material/Inventory';

export const PrimeChannelHeader = () => {
  const { client, channel } = useChatContext();
  let intPhoneNumber = '+';
  if (channel.data.countryCode) intPhoneNumber += channel.data.countryCode;
  if (channel.data.phoneNumberRaw) intPhoneNumber += channel.data.phoneNumberRaw;
  const parsedPhoneNumber = parseMax(intPhoneNumber, { defaultCountry: '', extract: false });
  return (
    <Grid container direction='row' justifyContent='flex-start' alignItems='center' spacing={0} sx={{ pl: 2, pr: 2, backgroundColor: 'white', height: 62, boxShadow: '0px 1px 0px rgba(0, 0, 0, 0.1)', overflowX: 'auto', flexWrap: 'nowrap'}}>
      <Box sx={{ width: '60px', textAlign: 'center', mr: 1}}>
        <Chip size='small' label={channel.data.channel_type && channel.data.channel_type === 'driver' ? 'unit' : channel.data.recordType} sx={{color: 'white', textTransform: 'capitalize', backgroundColor: channel.data.recordType ? prime_badgeColor(channel.data.recordType.toLowerCase()) : prime_badgeColor(channel.data.channel_type)}}/>
      </Box>
      <Box sx={{ minWidth: 'fit-content', mr: 1.5 }}>
        <Typography component='span'>{channel.data.firstName} {channel.data.lastName}</Typography>
        {parsedPhoneNumber && parsedPhoneNumber?.isValid() === true && <Link style={{ display: 'flex' }} href={parsedPhoneNumber.getURI()}>{`(${parsedPhoneNumber.country}) ${parsedPhoneNumber.formatInternational()}`}</Link>}
        {parsedPhoneNumber && parsedPhoneNumber?.isValid() === false && <Link style={{ display: 'flex', color: 'red', textDecorationColor: 'red' }}>{`(INVALID) ${parsedPhoneNumber.formatInternational()}`}</Link>}
        {!parsedPhoneNumber && <Link style={{ display: 'flex', color: 'red', textDecorationColor: 'red' }}>{`(INVALID) ${intPhoneNumber}`}</Link>}
      </Box>
      { channel.data.type === 'prime' && typeof channel.data.unitCode === 'string' && channel.data.unitCode !== '' && <ChipUnitCodes channel={channel} onHeader={true}/> }
      <Box sx={{ flexGrow: 1 }}/>
      { channel.data.frozen === true &&
      <Box sx={{mr: 2}}>
        {countUnreadPerChannel(channel) > 0 && <PrimeManageModal channel={channel} client={client} />}
        <Chip size='small' label={<ArchiveIcon fontSize='small' sx={{marginBottom: '-4px'}} />} color={'error'} sx={{backgroundColor: '#ff8787'}}/>
      </Box> }
      { channel.data.frozen === false &&
      <Box>
        {countUnreadPerChannel(channel) > 0 && <PrimeManageModal channel={channel} client={client} />}
        { channel.data.channel_type === 'phonebook' && <PrimeEditModal channel={channel} />}
      </Box> }
    </Grid>
  );
};